import { apiClient } from 'api'
import { Document } from 'types/documents'

type NewItem = Omit<Document, 'id'>

export const getDocuments = () => apiClient.get<Document[]>('/documents')

export const getDocumentById = (id: number) => apiClient.get<Document>(`/documents/${id}`)

export const createDocument = (document: NewItem) => apiClient.post<NewItem, Document>('/documents', document)

export const editDocument = (document: Document) => apiClient.patch<Document>(`/documents/${document.id}`, document)

export const deleteDocument = (id: number) => apiClient.delete(`/documents/${id}`)
